module.exports = __webpack_public_path__ + "img/add-account-icon.12e22c94.svg";